var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Gallery',{staticClass:"C-fragment-media--gallery",attrs:{"content":_vm.content,"settings":_vm.settings}})}
var staticRenderFns = []

export { render, staticRenderFns }